import { WaterCompositeDto } from '../types/water-composite-dto';
import { WaterFinalInvoiceService } from '@app/services/water-final-invoice/classes/water-final-invoice-service';
import { WaterNewContractService } from '@app/services/water-new-contract/classes/water-new-contract-service';
import { WaterTransferDocumentService } from '@app/services/water-transfer-document/classes/water-transfer-document-service';

export class WaterComposite {
    waterFinalInvoiceService?: WaterFinalInvoiceService;
    waterNewContractService?: WaterNewContractService;
    waterTransferDocumentService?: WaterTransferDocumentService;

    constructor(partial: WaterCompositeDto) {
        this.waterFinalInvoiceService = partial.waterFinalInvoiceService;
        this.waterNewContractService = partial.waterNewContractService;
        this.waterTransferDocumentService = partial.waterTransferDocumentService;
    }
}
